// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class TokenVerifyRequestMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_PFIX_TOKEN_VERIFY_REQUEST, fieldSet);
    }
    SetUserSessionId(accessToken) {
        this.setFieldValue(FieldsFactory.FIELD_ACCESS_TOKEN, accessToken);
    }
}
